import "./App.css";
import "./index.css";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  useRouteMatch,
  useParams,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";

import {
  createDarkTheme,
  createLightTheme,
  darkTheme,
  lightTheme,
} from "./theme/theme1";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// import '@fortawesome/fontawesome-free/css/all.min.css';
import Login from "./Components/Login/Login";
import Signup from "./Components/Signup/Signup";
import Otp from "./Components/OTP/Otp";
import ForgetPassword from "./Components/Forget-Password/ForgetPassword";
import RegistrationSuccessful from "./Components/Registation-Successful/RegistrationSuccessful";
import Header from "./Components/Header/Header";
import Dashboard from "./Components/IdentityVerification";
import Spot from "./Components/Spot";
import SpotPublic from "./Components/Spot/SpotPublic";
import OrderBookPage from "./Components/OrderBook/OrderBookPage";
import CoinPriceOverview from "./Components/CoinPrice/CoinPriceOverview";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import TermsAndConditions from "./Components/Terms/TermsOfUse";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import ConvertComponent from "./Components/Convert/Convert";
import FuturesDashboard from "./Components/Futures";
import Otc from "./Components/OTC/Otc";
import ProfileInfo from "./Components/Profile-info/ProfileInfo";
import BankDetails from "./Components/Bank-details/BankDetails";
import Settings from "./Components/Settings/Settings";
import OptionDashboard from "./Components/OptionDashboard";
import OptionChartDashboard from "./Components/OptionDashboard/OptionChartDashboard";
import AddressManagement from "./Components/Address-Management/AddressManagement";
import RecurringPayments from "./Components/Recurring-Payments/RecurringPayment";
import MyWalletDashboard from "./Components/MyWallet";
import CapturePhoto from "./Components/IdentityVerification/CapturePhoto";
import History from "./Components/History/History";
import Report from "./Components/Report/Report";
import DepositFundsPage from "./Components/Deposit-Fiat/DepositFundsPage";
import WithdrawFundsPage from "./Components/Withdraw-funds/WithdrawFundsPage";
import P2pDashboard from "./Components/P2P-Trading/P2pDashboard";
import P2POrderDetails from "./Components/P2P-Trading/P2POrderDetails";
import CopyTradeDashboard from "./Components/CopyTrade/CopyTradeDashboard";
import ApiKey from "./Components/CopyTrade/ApiKey";
import MyBots from "./Components/CopyTrade/MyBots";
// import MyBotsNew from "./Components/CopyTrade/MyBotsNew";

import CreateBot from "./Components/CopyTrade/CreateBot";
import MarketPlace from "./Components/CopyTrade/MarketPlace";
import TraderProfile from "./Components/CopyTrade/TraderProfile";
import MyFollowers from "./Components/CopyTrade/MyFollwers";
import SellOrderDetailsPage from "./Components/P2P-Trading/P2PSellOrderDetails";
import P2PPublicProfile from "./Components/P2P-Trading/P2PPublicProfile";
import P2PMyProfile from "./Components/P2P-Trading/P2PMyProfile";
import MyPayouts from "./Components/CopyTrade/MyPayouts";
import ManageApiKeysAndBots from "./Components/CopyTrade/ManageApiKeysAndBots";
import CopyTradingHistory from "./Components/CopyTrade/CopyTradingHistory";
import P2PMyOrders from "./Components/P2P-Trading/P2PMyOrders";
import P2PPostAd from "./Components/P2P-Trading/P2PPostAdForm";
import P2PMyAdsPage from "./Components/P2P-Trading/P2PMyAds";
import OrdersByAdPage from "./Components/P2P-Trading/P2POrdersByAd";
import EarnInterest from "./Components/Banking/Earn/Earn";
import CryptoLoans from "./Components/Banking/Loan/Loan";
import LoanOverview from "./Components/Banking/Loan/LoanOverview";
import AssetManagement from "./Components/Management/AssetManagement";
import AccountManagement from "./Components/Management/AccountManagement";
import OrderManagement from "./Components/Management/OrderManagement";
import PortfolioInvestPage from "./Components/Banking/Portfolio/Portfolio";
import MiningPoolPage from "./Components/Mining-Pool/miningPool";
import TransuctionHistory from "./Components/Management/TransuctionHistory";
import LoginHistory from "./Components/Management/LoginHistory";
import ChatApp from "./Components/Broker-chat/BrokerChat";
import P2PWalletPage from "./Components/P2P-Trading/P2PWalletPage";

import EarnWallet from "./Components/EarnWallet/EarnWallet";
import IssuerInterestPayableWallet from "./Components/SecurityInterestWallet/IssuerInterestPayableWallet";
import InvestorInterestAccruedWallet from "./Components/SecurityInterestWallet/InvestorInterestAccruedWallet";
import IssuerPrincipalPayableWallet from "./Components/SecurityInterestWallet/IssuerPrincipalPayableWallet";
import WebThreeWallet from "./Components/Web3Wallet/WebThreeWallet";
import PortfolioWallet from "./Components/Banking/Portfolio/PortfolioWallet";
import PromotionsPage from "./Components/Referral/Referral";
import EarnHistory from "./Components/Banking/Earn/EarnHistory";
import LoanHistory from "./Components/Banking/Loan/LoanHistory";
import PortfolioHistory from "./Components/Banking/Portfolio/PortfolioHistory";
import DeviceMismatchPage from "./Components/Login/deviceMismatchPage";
import { useSelector } from "react-redux";
// import logo from "../src/Assets/Images/paybito.png";
import { updateFCMToken, handleIncomingFCM } from "./firebase";
import ErrorBoundaryWrapper from "./ErrorBoundaryWrapper";
import P2pAppealProgressStatus from "./Components/P2P-Trading/P2P-appeal-progress";
import EditBot from "./Components/CopyTrade/EditBot";
import PaybitoInfo from "./PaybitoInfo";
import { DEMOBROKERDOMAIN } from "./CoreDataService";
import ErrorDialog from "./Common/ErrorDialog";

import SocialSignupPage from "./Components/Signup/SocialSignup";
import ExchangeFees from "./ExchangeFee/ExchangeFees";
import WhomIFollow from "./Components/CopyTrade/WhomIFollow";
import { IdleTimerProvider, useIdleTimer } from "react-idle-timer";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  Avatar,
  Badge,
} from "@mui/material";
import CoinMiningInstruction from "./Components/Mining-Pool/MiningPoolInstruction";
import TravelRuleLogin from "./Components/TravelRule.js/TravelRuleLogin";
import TravelRuleOriginatorInfo from "./Components/TravelRule.js/TravelRuleOriginatorInfo";
import TravelRuleRecipientInfo from "./Components/TravelRule.js/TravelRuleRecipientInfo";
import Authorize from "./Components/Authorize/Authorize";
import AccreditedKYC from "./Components/Accredited-Kyc";
import AutoLogin from "./Components/AutoLogin";

// Inside your App return:

// Preserves query params (e.g. callFrom=payments&invoice_id=...) when redirecting to /login.
// Also stores the originally requested path so Login can redirect back after auth
// (e.g. /recurring-payment, /spot, /my-wallet).
const CatchAllRedirect = () => {
  const location = useLocation();
  const path = location.pathname || "";
  const skip = [
    "/",
    "/login",
    "/signup",
    "/social-signup",
    "/otp",
    "/forget-password",
    "/registration-successful",
    "/autologin",
    "/verify",
  ];
  if (path && !skip.includes(path)) {
    localStorage.setItem(
      "redirectAfterLogin",
      `${path}${location.search || ""}`
    );
  }
  return <Navigate to={`/login${location.search}`} replace />;
};

const updateMetaTag = (selector, content) => {
  const tag = document.querySelector(selector);
  if (tag && content) {
    tag.setAttribute("content", content);
  }
};

// Runtime broker config — fetched from /site-config.json (written by
// scripts/inject-seo.js post-build). One build serves every broker; this file
// swaps per-broker on Apache without rebuilding.
const DEFAULT_SITE_CONFIG = {
  brokerId: "",
  name: "",
  title: "",
  description: "",
  keywords: "",
  domain: "",
  companyName: "",
  companyWebsite: "",
  exchangeLogo: "",
  colors: {},
  brokerInfo: {},
};

function App() {
  const navigate = useNavigate();
  const [token, setToken] = useState(null); // Start with null instead of empty string
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(true); // toggle this for theme switch
  const { brokerBasicInfo, allColors } = useSelector((state) => state);
  const themeColor = localStorage.getItem("theme");

  const [logoutWarningModal, setLogoutWarningModal] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const countdownRef = useRef(null);
  const [containerStyle, setContainerStyle] = useState({});
  const [siteConfig, setSiteConfig] = useState(DEFAULT_SITE_CONFIG);

  // Extract the page name from the URL
  const pageName = location.pathname.split("/").pop();
  console.log("Current page name:", pageName);

  // Load per-broker runtime config. scripts/inject-seo.js writes this file
  // into the build directory alongside the SEO-injected index.html.
  useEffect(() => {
    fetch("/site-config.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((cfg) => {
        if (cfg) {
          setSiteConfig({
            ...DEFAULT_SITE_CONFIG,
            ...cfg,
            colors: { ...DEFAULT_SITE_CONFIG.colors, ...(cfg.colors || {}) },
          });
        }
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    updateFavicon();
  }, [pageName, brokerBasicInfo?.exchangeLogo]);
  useEffect(() => {
    document.title = siteConfig.title || siteConfig.name || "Default Website";
    updateMetaTag('meta[name="description"]', siteConfig.description);
    updateMetaTag('meta[name="keywords"]', siteConfig.keywords);
    updateMetaTag(
      'meta[property="og:title"]',
      siteConfig.title || siteConfig.name
    );
    updateMetaTag('meta[property="og:description"]', siteConfig.description);
    updateMetaTag('meta[property="og:url"]', siteConfig.domain);
    updateMetaTag(
      'meta[name="twitter:title"]',
      siteConfig.title || siteConfig.name
    );
    updateMetaTag('meta[name="twitter:description"]', siteConfig.description);
    updateMetaTag(
      'meta[name="theme-color"]',
      siteConfig.colors.darkNavbarColor ||
      siteConfig.colors.navbarColor ||
      "#000000"
    );
  }, [siteConfig]);
  useEffect(() => {
    const body = document.body;

    if (allColors) {
      let bodyColor, navbarColor;

      if (themeColor === "dark") {
        bodyColor = allColors.darkBackgroundColor || "#000";
        navbarColor = allColors.darkNavbarColor || "#000";

        body.style.setProperty("--btn-color", allColors.internalButtonColor);
        body.style.setProperty(
          "--button-active",
          allColors.internalButtonColor
        );
        body.style.setProperty(
          "--popupheader-color",
          allColors.popupHeaderColor
        );
        body.style.setProperty("--popupbody-color", allColors.popupBodyColor);
        body.style.setProperty("--text-color", allColors.fontColor);

        // Keep color-mix string, just change the base variable
        body.style.setProperty("--body-color", bodyColor);
        body.style.setProperty("--navbar-color", navbarColor);
        body.style.setProperty(
          "--body-color-less",
          `color-mix(in srgb, ${bodyColor}, white 6%)`
        );
        body.style.setProperty(
          "--body-color-less2",
          `color-mix(in srgb, ${bodyColor}, white 12%)`
        );
        body.style.setProperty(
          "--navbar-color-less",
          `color-mix(in srgb, ${navbarColor}, white 6%)`
        );
        body.style.setProperty(
          "--navbar-color-less2",
          `color-mix(in srgb, ${navbarColor}, white 14%)`
        );
        body.style.setProperty(
          "--popup-body-less",
          `color-mix(in srgb, ${allColors.popupBodyColor}, white 5%)`
        );
        body.style.setProperty("--font-style", allColors.fontStyle);
      } else {
        bodyColor = allColors.lightBackgroundColor || "#fff";
        navbarColor = allColors.lightNavbarColor || "#fff";

        body.style.setProperty(
          "--btn-color",
          allColors.lightInternalButtonColor
        );
        body.style.setProperty(
          "--button-active",
          allColors.lightInternalButtonColor
        );
        body.style.setProperty(
          "--popupheader-color",
          allColors.lightPopupHeaderColor
        );
        body.style.setProperty(
          "--popupbody-color",
          allColors.lightTableHeaderColor
        );
        body.style.setProperty("--text-color", allColors.lightFontColor);

        body.style.setProperty("--body-color", bodyColor);
        body.style.setProperty("--navbar-color", navbarColor);
        body.style.setProperty(
          "--body-color-less",
          `color-mix(in srgb, ${bodyColor}, black 5%)`
        );
        body.style.setProperty(
          "--body-color-less2",
          `color-mix(in srgb, ${bodyColor}, black 10%)`
        );
        body.style.setProperty(
          "--navbar-color-less",
          `color-mix(in srgb, ${navbarColor}, black 4%)`
        );
        body.style.setProperty(
          "--navbar-color-less2",
          `color-mix(in srgb, ${navbarColor}, black 8%)`
        );
        body.style.setProperty(
          "--popup-body-less",
          `color-mix(in srgb, ${allColors.lightPopupBodyColor}, black 5%)`
        );
        body.style.setProperty("--font-style", allColors.lightFontStyle);
      }
    }
  }, [allColors, themeColor]);

  console.log("containerStyle", containerStyle, allColors);

  const toPascalCase = (str) => {
    return str
      .replace(/[_-]/g, " ") // replace underscores/hyphens with spaces
      .replace(/([a-z])([A-Z])/g, "$1 $2") // separate camelCase
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join("");
  };

  const updateFavicon = () => {
    const storedToken =
      localStorage.getItem("access_token") ||
      localStorage.getItem("access_token");
    const currentLogo =
      brokerBasicInfo?.exchangeLogo || localStorage.getItem("exchangeLogo");
    if (currentLogo) {
      const head = document.getElementsByTagName("head")[0];
      const existingIcons = document.querySelectorAll(
        "link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon'], link[rel='apple-touch-icon-precomposed']"
      );
      existingIcons.forEach(
        (el) => el.parentNode && el.parentNode.removeChild(el)
      );

      const icon = document.createElement("link");
      icon.rel = "icon";
      icon.href = currentLogo;
      head.appendChild(icon);

      const shortcut = document.createElement("link");
      shortcut.rel = "shortcut icon";
      shortcut.href = currentLogo;
      head.appendChild(shortcut);

      const appleIcon = document.createElement("link");
      appleIcon.rel = "apple-touch-icon";
      appleIcon.href = currentLogo;
      head.appendChild(appleIcon);
    }
    const exchangeName = localStorage.getItem("exchange") || "";

    document.title = `${exchangeName} ${pageName ? toPascalCase(pageName) : storedToken ? "Spot" : "Login"
      } | ${exchangeName}`;
    // document.title = `PayBitoPro ${
    //   pageName ? toPascalCase(pageName) : storedToken ? "Spot" : "Login"
    // } | PayBitoPro`;
  };

  useEffect(() => {
    if (themeColor === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [themeColor]);

  useEffect(() => {
    updateFCMToken();
  }, []);

  // After any login flow completes and token becomes available, honor any
  // pre-login path saved by CatchAllRedirect (e.g. /recurring-payment).
  useEffect(() => {
    if (!token) return;
    const target = localStorage.getItem("redirectAfterLogin");
    if (!target) return;
    localStorage.removeItem("redirectAfterLogin");
    const pathOnly = target.split("?")[0].replace(/\/+$/, "");
    const blocked = [
      "",
      "/",
      "/login",
      "/signup",
      "/social-signup",
      "/forget-password",
      "/otp",
      "/registration-successful",
      "/autologin",
      "/verify",
    ];
    if (blocked.includes(pathOnly)) return;
    navigate(target, { replace: true });
  }, [token]);

  useEffect(() => {
    const storedToken =
      localStorage.getItem("access_token") ||
      localStorage.getItem("access_token");

    setToken(storedToken);
    setLoading(false); // Token has been checked, stop loading

    if (themeColor !== null) {
      localStorage.setItem("theme", themeColor);
    } else {
      localStorage.setItem("theme", "dark");
    }

    if (localStorage.getItem("theme") == "dark") {
      setIsDarkMode(true);
    } else {
      setIsDarkMode(false);
    }
  }, [pageName]);

  useEffect(() => {
    const handleWheel = (e) => {
      if (
        document.activeElement.type === "number" &&
        document.activeElement === e.target
      ) {
        e.preventDefault();
      }
    };

    const handleArrowKeys = (e) => {
      if (
        document.activeElement.type === "number" &&
        (e.key === "ArrowUp" || e.key === "ArrowDown")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("keydown", handleArrowKeys);

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("keydown", handleArrowKeys);
    };
  }, []);

  if (loading) return null; // Or a loading spinner if you prefer

  const isDomainValid = () => {
    return DEMOBROKERDOMAIN === window.location.origin;
  };

  const handleOnIdle = () => {
    setLogoutWarningModal(true);
    setCountdown(60);

    const endTime = Date.now() + 60000;

    countdownRef.current = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(0, Math.ceil((endTime - now) / 1000));

      setCountdown(remaining);

      if (remaining <= 0) {
        clearInterval(countdownRef.current);
        handleLogout();
      }
    }, 1000);
  };

  const handleOnActive = () => { };
  const handleContinue = () => {
    clearInterval(countdownRef.current);
    setLogoutWarningModal(false);
  };

  // Logout function
  const handleLogout = () => {
    clearInterval(countdownRef.current);
    // const url = `/login?broker-id=${localStorage.getItem("brokerId")}`;
    localStorage.clear();
    // localStorage.setItem('brokerId',BROKERID)
    navigate("/");
    window.location.reload();
  };

  const mockData = {
    styleOne: true,
    bakgColor: "#000",
    backgroundNavColorDynamic: "#2c3e50",
    backgroundButtonColorDynamic: "#3498db",
    logo: "./assets/logo.png",
    exchange: "PayBito",
  };

  const AuthenticatedRoute = () => (
    <ThemeProvider
      // theme={isDarkMode ? darkTheme : lightTheme}
      theme={
        isDarkMode ? createDarkTheme(allColors) : createLightTheme(allColors)
      }
    >
      <CssBaseline /> {/* Ensures dark mode applies globally */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <Header />

        {/* <ErrorBoundaryWrapper> */}
        <IdleTimerProvider
          timeout={1000 * 60 * 60 * 24} // 24 hours in ms
          onIdle={handleOnIdle}
          onActive={handleOnActive}
          debounce={500}
        >
          {localStorage.getItem("access_token") && (
            <Dialog
              open={logoutWarningModal}
              onClose={() => setLogoutWarningModal(false)}
              fullWidth
              maxWidth="xs"
              PaperProps={{
                sx: {
                  borderRadius: 3,
                },
              }}
            >
              {/* Header */}
              <DialogTitle
                sx={{
                  position: "relative",
                  textAlign: "center",
                  px: 4,
                  pb: 1,
                }}
              >
                <Typography variant="h6">About to Log out</Typography>
              </DialogTitle>

              {/* Body */}
              <DialogContent
                sx={{
                  textAlign: "center",
                  px: 4,
                  py: 3,
                  mt: 2,
                }}
              >
                <Typography variant="body1">
                  You are going to Log out in {countdown} seconds. Click
                  continue to resume this session.
                </Typography>
              </DialogContent>

              {/* Actions */}
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pb: 3,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleContinue}
                  color="error"
                >
                  Continue
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Routes>
            <Route path="/exchange-fees" element={<ExchangeFees />} />
            <Route path="/platform-fees" element={<ExchangeFees />} />

            <>
              {/* <Route path="/" element={<Dashboard />} /> */}
              <Route path="/" element={<Navigate to="/spot" replace />} />
              <Route path="/spot" element={<Spot />} />
              <Route path="/trade/:pair" element={<SpotPublic />} />
              <Route path="/price/:coin" element={<CoinPriceOverview />} />
              <Route path="/price" element={<CoinPriceOverview />} />
              <Route path="/orderbook/:pair" element={<OrderBookPage />} />
              <Route path="/orderbook" element={<OrderBookPage />} />

              <Route path="/futures" element={<FuturesDashboard />} />
              <Route path="/options-chain" element={<OptionDashboard />} />
              <Route path="/options" element={<OptionChartDashboard />} />
              <Route path="/identity-verification" element={<Dashboard />} />

              {/* Accredited Investor KYC Route */}
              <Route
                path="/accredited-investor-verification"
                element={<AccreditedKYC />}
              />
              <Route
                path="/basic"
                element={<Navigate to="/convert" replace />}
              />
              <Route path="/convert" element={<ConvertComponent />} />
              <Route path="/otc" element={<Otc />} />
              <Route path="/profile-info" element={<ProfileInfo />} />
              <Route path="/bank-details" element={<BankDetails />} />
              <Route
                path="/mobile-capture/:p1/:q1"
                element={<CapturePhoto />}
              />
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/address-management"
                element={<AddressManagement />}
              />
              <Route
                path="/recurring-payments"
                element={<Navigate to="/recurring-payment" replace />}
              />
              <Route
                path="/recurring-payment"
                element={<RecurringPayments />}
              />

              <Route path="/my-wallet" element={<MyWalletDashboard />} />
              <Route
                path="/copy-trading"
                element={<Navigate to="/copy-trade" replace />}
              />
              <Route path="/copy-trade" element={<CopyTradeDashboard />} />
              <Route path="/add-apiKey" element={<ApiKey />} />
              <Route path="/my-bots" element={<MyBots />} />
              {/* <Route path="/my-bots-new" element={<MyBotsNew />} /> */}

              <Route path="/create-new-bot" element={<CreateBot />} />
              <Route path="/edit-bot" element={<EditBot />} />
              <Route path="/marketplace" element={<MarketPlace />} />
              <Route path="/apiKey/:id" element={<TraderProfile />} />
              <Route path="/my-followers" element={<MyFollowers />} />
              <Route path="/whom-I-follow" element={<WhomIFollow />} />
              <Route path="/my-payouts" element={<MyPayouts />} />
              <Route
                path="/manage-copytrading"
                element={<ManageApiKeysAndBots />}
              />
              <Route
                path="/copy-trading-history"
                element={<CopyTradingHistory />}
              />
              <Route path="/History" element={<History />} />
              <Route path="/report" element={<Report />} />
              <Route path="/Deposit" element={<DepositFundsPage />} />
              <Route path="/Withdraw" element={<WithdrawFundsPage />} />

              <Route path="/p2p/dashboard" element={<P2pDashboard />} />
              <Route path="/p2p/order-details" element={<P2POrderDetails />} />
              <Route
                path="/p2p/sell-order-details"
                element={<SellOrderDetailsPage />}
              />
              <Route
                path="/p2p/public-profile/:uuid"
                element={<P2PPublicProfile />}
              />
              <Route path="/p2p/my-profile" element={<P2PMyProfile />} />
              <Route path="/p2p/my-orders" element={<P2PMyOrders />} />
              <Route path="/p2p/post-ad" element={<P2PPostAd />} />
              <Route path="/p2p/my-ads" element={<P2PMyAdsPage />} />
              <Route
                path="/p2p/p2p-appeal-progress"
                element={<P2pAppealProgressStatus />}
              />

              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />

              <Route path="otp" element={<Otp />} />
              <Route path="forget-password" element={<ForgetPassword />} />
              <Route
                path="registration-successful"
                element={<RegistrationSuccessful />}
              />
              <Route path="terms-of-use" element={<TermsAndConditions />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/mobile-capture/:p1/:q1"
                element={<CapturePhoto />}
              />
              <Route path="verify" element={<DeviceMismatchPage />} />
              <Route
                path="/p2p/orders-by-ad/:adId"
                element={<OrdersByAdPage />}
              />
              <Route path="/p2p/p2p-wallet" element={<P2PWalletPage />} />

              <Route path="/earn-interest" element={<EarnInterest />} />

              <Route path="/crypto-loans" element={<CryptoLoans />} />
              <Route path="/loan-overview" element={<LoanOverview />} />
              <Route path="/asset-management" element={<AssetManagement />} />
              <Route
                path="/account-management"
                element={<AccountManagement />}
              />
              <Route path="/order-management" element={<OrderManagement />} />
              <Route
                path="/portfolio-invest"
                element={<PortfolioInvestPage />}
              />
              <Route
                path="/mining/pool"
                element={<Navigate to="/mining-pool" replace />}
              />
              <Route path="/mining-pool" element={<MiningPoolPage />} />

              <Route
                path="/portfolio-invest"
                element={<PortfolioInvestPage />}
              />
              <Route
                path="/transaction-history"
                element={<TransuctionHistory />}
              />
              <Route path="/login-history" element={<LoginHistory />} />
              <Route path="/chat" element={<ChatApp />} />
              <Route path="/earn-interest-wallet" element={<EarnWallet />} />
              <Route
                path="/interest-payable-wallet"
                element={<IssuerInterestPayableWallet />}
              />
              <Route
                path="/interest-accrued-wallet"
                element={<InvestorInterestAccruedWallet />}
              />
              <Route
                path="/principal-payable-wallet"
                element={<IssuerPrincipalPayableWallet />}
              />
              <Route path="/web3-wallet" element={<WebThreeWallet />} />
              <Route path="/portfolio-wallet" element={<PortfolioWallet />} />
              <Route path="/promotion" element={<PromotionsPage />} />
              <Route path="/earn-history" element={<EarnHistory />} />
              <Route path="/loan-history" element={<LoanHistory />} />
              <Route path="/portfolio-history" element={<PortfolioHistory />} />
              <Route
                path="/:coin-mining-instruction"
                element={<CoinMiningInstruction />}
              />
              <Route
                path="/travel-rule-authentication"
                element={<TravelRuleLogin data={mockData} />}
              />
              <Route
                path="/travel-rule-originator-info"
                element={<TravelRuleOriginatorInfo data={mockData} />}
              />
              <Route
                path="/travel-rule-recipient-info"
                element={<TravelRuleRecipientInfo data={mockData} />}
              />
              <Route path="/authorize" element={<Authorize />} />
              <Route path="/sandbox/authorize" element={<Authorize />} />
            </>
          </Routes>
        </IdleTimerProvider>
        {/* </ErrorBoundaryWrapper> */}
        {isDomainValid() && <PaybitoInfo />}
        <ErrorDialog />
      </div>
    </ThemeProvider>
  );

  const publicRoute = () => (
    <>
      <CssBaseline /> {/* Ensures dark mode applies globally */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <Header />

        <Routes>
          <>
            <Route path="/exchange-fees" element={<ExchangeFees />} />
            <Route path="/platform-fees" element={<ExchangeFees />} />
            <Route path="/trade/:pair" element={<SpotPublic />} />
            <Route path="/price/:coin" element={<CoinPriceOverview />} />
            <Route path="/price" element={<CoinPriceOverview />} />
            <Route path="/orderbook/:pair" element={<OrderBookPage />} />
            <Route path="/orderbook" element={<OrderBookPage />} />
            <Route path="/" element={<Login />} />

            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="autologin" element={<AutoLogin />} />

            <Route path="social-signup" element={<SocialSignupPage />} />

            <Route path="otp" element={<Otp />} />
            <Route path="forget-password" element={<ForgetPassword />} />
            <Route
              path="registration-successful"
              element={<RegistrationSuccessful />}
            />
            <Route path="terms-of-use" element={<TermsAndConditions />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/mobile-capture/:p1/:q1" element={<CapturePhoto />} />
            <Route path="verify" element={<DeviceMismatchPage />} />
            <Route
              path="/travel-rule-authentication"
              element={<TravelRuleLogin data={mockData} />}
            />
            <Route
              path="/travel-rule-originator-info"
              element={<TravelRuleOriginatorInfo data={mockData} />}
            />
            <Route
              path="/travel-rule-recipient-info"
              element={<TravelRuleRecipientInfo data={mockData} />}
            />

            <Route path="*" element={<CatchAllRedirect />} />
          </>
        </Routes>
        {isDomainValid() && <PaybitoInfo />}
      </div>
    </>
  );

  // Standalone Coin Price route — accessible without login, zero auth API calls
  if (location.pathname.startsWith("/price")) {
    const isLoggedIn = !!(token || localStorage.getItem("access_token"));
    const navBg =
      (isDarkMode
        ? siteConfig?.colors?.darkNavbarColor
        : siteConfig?.colors?.lightNavbarColor) ||
      siteConfig?.colors?.navbarColor ||
      "#181a20";

    return (
      <ThemeProvider
        theme={
          isDarkMode ? createDarkTheme(allColors) : createLightTheme(allColors)
        }
      >
        <CssBaseline />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            position: "relative",
            ...containerStyle,
          }}
        >
          {isLoggedIn ? (
            <Header />
          ) : (
            <nav
              style={{
                background: navBg,
                boxShadow:
                  "0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12)",
                padding: "0 20px",
                display: "flex",
                alignItems: "center",
                height: "56px",
              }}
            >
              <Link to="/spot">
                <img
                  src={siteConfig?.exchangeLogo}
                  alt={siteConfig?.name || "PayBito"}
                  style={{ height: "40px", objectFit: "contain" }}
                />
              </Link>
            </nav>
          )}
          <Routes>
            <Route path="/price/:coin" element={<CoinPriceOverview />} />
            <Route path="/price" element={<CoinPriceOverview />} />
          </Routes>
        </div>
      </ThemeProvider>
    );
  }

  // Standalone orderbook view — accessible without login, zero auth API calls
  if (location.pathname.startsWith("/orderbook")) {
    return (
      <ThemeProvider
        theme={
          isDarkMode ? createDarkTheme(allColors) : createLightTheme(allColors)
        }
      >
        <CssBaseline />
        <Routes>
          <Route path="/orderbook/:pair" element={<OrderBookPage />} />
          <Route path="/orderbook" element={<OrderBookPage />} />
        </Routes>
      </ThemeProvider>
    );
  }

  // Public trade view — accessible without login, zero auth API calls
  if (location.pathname.startsWith("/trade/")) {
    const isLoggedIn = !!(token || localStorage.getItem("access_token"));
    const navBg =
      (isDarkMode
        ? siteConfig.colors.darkNavbarColor
        : siteConfig.colors.lightNavbarColor) || siteConfig.colors.navbarColor;

    return (
      <ThemeProvider
        theme={
          isDarkMode ? createDarkTheme(allColors) : createLightTheme(allColors)
        }
      >
        <CssBaseline />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            position: "relative",
            ...containerStyle,
          }}
        >
          {isLoggedIn ? (
            <Header />
          ) : (
            <nav
              style={{
                background: navBg,
                boxShadow:
                  "0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12)",
                padding: "0 20px",
                display: "flex",
                alignItems: "center",
                height: "56px",
              }}
            >
              <Link to="/login">
                <img
                  src={siteConfig.exchangeLogo}
                  alt={siteConfig.name}
                  style={{ height: "40px", objectFit: "contain" }}
                />
              </Link>
            </nav>
          )}
          <Routes>
            <Route path="/trade/:pair" element={<SpotPublic />} />
          </Routes>
        </div>
      </ThemeProvider>
    );
  }

  // If on autologin page, render only AutoLogin without Header or other components
  // to prevent any API calls before the token is obtained
  if (location.pathname === "/autologin") {
    return (
      <div style={containerStyle}>
        <Routes>
          <Route path="autologin" element={<AutoLogin />} />
        </Routes>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      {token || localStorage.getItem("access_token")
        ? AuthenticatedRoute()
        : publicRoute()}
    </div>
  );
}

export default App;
